import { gql } from '@apollo/client'
import { userErrorFragment } from '~/graphql/fragments/userError'

export const START_EMAIL_VERIFICATION = gql`
  mutation StartUserEmailVerification($input: StartUserEmailVerificationInput!) {
    startUserEmailVerification(input: $input) {
      errors {
        ...userError
      }
    }
  }
  ${userErrorFragment}
`
